(() => {
  if (customElements.get('hdp-stock-locations')) return;
  const requests = new Map();
  const load = (url) => {
    if (!requests.has(url)) requests.set(url, fetch(url, { credentials: 'omit' }).then((response) => {
      if (!response.ok) throw new Error('Stock unavailable');
      return response.json();
    }));
    return requests.get(url);
  };
  class StockLocations extends HTMLElement {
    connectedCallback() {
      this.parentElement?.classList.remove('hdp-stock-ready');
      this.renderStock();
    }
    disconnectedCallback() { clearTimeout(this.expiryTimer); }
    async renderStock() {
      try {
        const data = await load(this.dataset.source);
        const expires = Date.parse(data.expiresAt);
        const checked = Date.parse(data.checkedAt);
        const groups = data.variants[this.dataset.variant];
        const sources = ['shop', 'pu', 'wps'];
        if (!this.isConnected || data.schema !== 2 || !Number.isFinite(expires) ||
          !Number.isFinite(checked) || checked > Date.now() || expires <= Date.now() ||
          !Array.isArray(groups) || !groups.length || !groups.every((group) =>
            sources.includes(group.source) && Array.isArray(group.rows) && group.rows.length && group.rows.every((row) =>
              Array.isArray(row) && row.length === 2 && typeof row[0] === 'string' &&
              (row[1] === null || row[1] === 'N/A' || (typeof row[1] === 'string' && /^\d+\+?$/.test(row[1])))))) return;
        const content = [];
        groups.forEach((group) => {
          const block = document.createElement('span');
          block.className = 'hdp-stock-group';
          group.rows.forEach(([location, quantity]) => {
            const row = document.createElement('span');
            row.className = 'hdp-stock-row';
            const name = document.createElement('span');
            const state = group.source === 'shop' ? 'ID' : location.match(/(?:^|,\s*)([A-Z]{2})$/)?.[1];
            if (!state) throw new Error('Warehouse state unavailable');
            name.textContent = state;
            row.setAttribute('aria-label', group.source === 'shop' ? 'Local shop, Idaho' : location);
            const count = document.createElement('strong');
            const unknown = quantity === null || quantity === 'N/A';
            count.textContent = unknown ? '—' : quantity;
            if (unknown) count.setAttribute('aria-label', this.dataset.unknown || 'Not reported');
            row.append(name, count);
            block.append(row);
          });
          content.push(block);
        });
        this.replaceChildren(...content);
        this.parentElement.classList.add('hdp-stock-ready');
        this.expiryTimer = setTimeout(() => {
          this.parentElement?.classList.remove('hdp-stock-ready');
          this.replaceChildren();
        }, Math.min(expires - Date.now(), 2147483647));
      } catch { this.parentElement?.classList.remove('hdp-stock-ready'); }
    }
  }
  customElements.define('hdp-stock-locations', StockLocations);
})();
